export const services = [
  {
    slug: 'domain-registration',
    name: '域名注册',
    icon: 'ri-global-line',
    description: '提供超过 500 种域名后缀注册服务，支持 .com、.cn、.net 等热门域名。智能域名查询系统，快速锁定心仪域名，支持批量注册与域名交易。',
    details: '91.cn 域名注册服务覆盖全球主流域名后缀，提供实时域名查询、智能推荐、批量注册、域名交易等一站式域名管理服务。我们与全球顶级域名注册局直接合作，确保域名注册快速、安全、稳定。无论您是初创企业还是大型集团，都能找到最适合的品牌域名。',
    features: ['实时域名查询', '智能域名推荐', '批量注册管理', '域名交易市场', 'DNS 解析管理', '域名隐私保护'],
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20domain%20registration%20concept%2C%20clean%20geometric%20globe%20with%20connected%20network%20nodes%20floating%20in%20abstract%20space%2C%20warm%20coral%20and%20teal%20gradient%20accents%2C%20soft%20diffused%20lighting%2C%20professional%20technology%20background%20with%20subtle%20grid%20pattern%2C%20editorial%20quality&width=1600&height=900&seq=domain-hero&orientation=landscape',
  },
  {
    slug: 'website-building',
    name: '网站建设',
    icon: 'ri-layout-4-line',
    description: '专业网站建设服务，涵盖企业官网、电商平台、门户网站等。可视化拖拽建站，上千套精美模板，零代码快速上线。',
    details: '91.cn 网站建设服务为您提供从域名注册到网站上线的一站式解决方案。我们拥有专业的设计团队和强大的建站平台，支持可视化拖拽操作、SEO 优化、移动端适配，让您的企业官网在最短时间内实现专业上线。',
    features: ['可视化拖拽建站', '上千套精美模板', '响应式设计', 'SEO 优化工具', '移动端适配', '7x24 技术支持'],
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20website%20building%20concept%2C%20clean%20digital%20workspace%20with%20floating%20UI%20elements%20and%20design%20tools%2C%20warm%20coral%20and%20teal%20gradient%20accents%2C%20abstract%20geometric%20shapes%2C%20soft%20diffused%20lighting%2C%20editorial%20quality%2C%20professional%20technology%20background&width=1600&height=900&seq=website-hero&orientation=landscape',
  },
  {
    slug: 'cloud-hosting',
    name: '云主机',
    icon: 'ri-cloud-line',
    description: '高性能云服务器，弹性伸缩，按需付费。采用 SSD 存储，多重备份机制，99.9% 可用性保障，让您的业务运行无忧。',
    details: '91.cn 云主机基于先进的云计算技术架构，提供弹性计算、高可用存储、安全防护等全方位云服务。支持按需扩容、实时监控、自动备份，满足从小型企业到大型企业的多样化需求，确保业务持续稳定运行。',
    features: ['弹性伸缩配置', 'SSD 高速存储', '多重数据备份', '99.9% 可用性', 'DDoS 防护', '实时资源监控'],
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20cloud%20hosting%20concept%2C%20abstract%20server%20racks%20floating%20in%20digital%20cloud%20formation%2C%20warm%20coral%20and%20teal%20gradient%20accents%2C%20clean%20geometric%20patterns%2C%20soft%20diffused%20lighting%2C%20editorial%20quality%2C%20professional%20technology%20background&width=1600&height=900&seq=cloud-hero&orientation=landscape',
  },
  {
    slug: 'enterprise-email',
    name: '企业邮箱',
    icon: 'ri-mail-line',
    description: '以企业域名为后缀的专业邮箱服务，支持无限存储、反垃圾邮件、多终端同步。提升企业品牌形象，保障商务沟通安全。',
    details: '91.cn 企业邮箱为您提供安全、稳定、高效的企业级邮件服务。支持自定义域名邮箱、超大附件传输、反垃圾邮件过滤、多终端实时同步，让您的商务沟通更加专业可靠。',
    features: ['自定义域名邮箱', '无限存储空间', '反垃圾邮件过滤', '多终端同步', '超大附件传输', '邮件加密保护'],
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20email%20concept%2C%20clean%20digital%20envelope%20with%20flowing%20communication%20lines%20in%20abstract%20space%2C%20warm%20coral%20and%20teal%20gradient%20accents%2C%20geometric%20shapes%2C%20soft%20diffused%20lighting%2C%20editorial%20quality%2C%20professional%20technology%20background&width=1600&height=900&seq=email-hero&orientation=landscape',
  },
];

export const articles = [
  {
    slug: 'how-to-choose-domain-name',
    title: '如何选择最适合您企业的域名？完整指南',
    category: 'domain-registration',
    date: '2026-07-28',
    summary: '域名是企业在线品牌的第一步。本文从品牌定位、SEO 优化、用户体验等多个维度，为您详细解析域名选择的核心原则和实用技巧。',
    content: `域名是企业在互联网上的"门牌号"，一个优秀的域名不仅能提升品牌形象，还能带来更多的自然流量。那么，如何才能选择一个最适合您企业的域名呢？

## 一、品牌一致性原则

域名应该与您的品牌名称保持一致。当用户看到您的域名时，应该能够立即联想到您的品牌。例如，如果您公司叫"星辰科技"，那么 xingchen.com 或 xc-tech.com 都是不错的选择。

### 建议：
- 尽量使用品牌全拼或核心词
- 避免使用数字和连字符
- 保持简短易记

## 二、域名后缀选择

不同的域名后缀代表着不同的含义和定位：
- .com：国际通用，商业首选
- .cn：中国市场标识
- .net：网络服务类企业
- .org：非营利组织
- .io：科技创业公司新宠

## 三、SEO 友好性

虽然谷歌已明确表示域名关键词不再是排名核心因素，但一个好记且有意义的域名能带来更多的直接访问和品牌搜索，间接提升 SEO 表现。

## 四、法律风险防范

在注册域名前，务必进行商标检索，避免侵犯他人商标权。91.cn 提供专业的域名查询和商标检测服务，帮助您规避风险。

## 结语

选择域名是企业数字化的第一步，也是最关键的一步。91.cn 提供全方位的域名注册和管理服务，助力您的企业在线成功起航。`,
  },
  {
    slug: 'trends-cloud-computing-2026',
    title: '2026 年云计算发展趋势与中小企业选型指南',
    category: 'cloud-hosting',
    date: '2026-07-15',
    summary: '云计算技术日新月异，2026 年又有哪些新趋势？中小企业如何选择最适合的云服务方案？本文为您深度解析。',
    content: `云计算已经深度融入各行各业。2026 年，云计算领域呈现出几个显著的发展趋势，值得每个企业关注。

## 一、边缘计算崛起

随着物联网设备爆发式增长，边缘计算成为云计算的重要补充。数据处理从中心云端向边缘节点迁移，大幅降低延迟，提升实时处理能力。

## 二、AI 原生云服务

云平台深度整合 AI 能力，提供预训练模型、智能数据分析等开箱即用的 AI 服务。中小企业无需自建 AI 团队，即可享受智能化红利。

## 三、多云和混合云架构

企业不再依赖单一云服务商，而是构建多云和混合云架构，实现更高的灵活性和容灾能力。

## 四、中小企业选型建议

1. 从实际需求出发，避免过度配置
2. 选择支持弹性伸缩的服务商
3. 关注数据安全和合规性
4. 考虑技术支持和服务质量

## 结语

91.cn 云主机服务紧跟技术前沿，为中小企业提供灵活、安全、高性价比的云计算方案。`,
  },
  {
    slug: 'website-building-guide',
    title: '企业官网建设全攻略：从零到上线的完整流程',
    category: 'website-building',
    date: '2026-06-20',
    summary: '建设一个专业的企业官网需要哪些步骤？本文详细梳理从规划、设计、开发到上线的完整流程，助您少走弯路。',
    content: `企业官网是品牌在线展示的核心阵地。一个专业的企业官网能有效提升品牌形象、吸引潜在客户。以下是建站的完整流程：

## 一、前期规划阶段

明确建站目的、目标用户、核心功能。做好竞品分析，制定内容策略。

## 二、域名与主机选择

选择合适的域名和稳定的云主机，这是网站稳定运行的基础。91.cn 提供一站式域名注册和云主机服务。

## 三、设计与开发

根据品牌调性进行页面设计，确保响应式布局，优化用户体验。

## 四、内容填充与 SEO

优质内容 + 合理的 SEO 策略，让网站获得更好的搜索排名。

## 五、测试与上线

全面测试网站功能和兼容性，确保上线后稳定运行。

## 结语

91.cn 网站建设服务为您提供从域名到上线的一站式解决方案，让建站变得简单高效。`,
  },
  {
    slug: 'enterprise-email-security',
    title: '企业邮箱安全防护指南：守护商业机密的第一道防线',
    category: 'enterprise-email',
    date: '2026-06-08',
    summary: '邮件是企业商务沟通的核心工具，也是网络攻击的高发渠道。了解企业邮箱安全防护措施，守护您的商业机密。',
    content: `企业邮箱承载着大量商业机密和客户信息，安全防护至关重要。

## 一、常见邮件安全威胁

钓鱼邮件、勒索软件、商业邮件诈骗（BEC）是企业面临的主要邮件安全威胁。

## 二、基础安全措施

1. 启用多因素认证（MFA）
2. 定期更新密码策略
3. 员工安全意识培训

## 三、高级防护技术

- AI 驱动的反垃圾邮件过滤
- 邮件加密传输
- 高级威胁防护（ATP）
- 数据防泄漏（DLP）

## 四、91.cn 企业邮箱安全优势

91.cn 企业邮箱采用多层次安全防护体系，从传输加密到AI智能过滤，全方位保障您的邮件安全。

## 结语

邮件安全不容忽视。选择 91.cn 企业邮箱，让专业的安全防护守护您的每一封邮件。`,
  },
  {
    slug: 'digital-transformation-sme',
    title: '中小企业数字化转型实践指南：路径、挑战与解决方案',
    category: 'website-building',
    date: '2026-05-25',
    summary: '数字化转型不是大企业的专利。本文探讨中小企业如何利用现有资源和工具，以最小成本实现数字化转型。',
    content: `数字化转型已成为企业发展的必选项。对于资源有限的中小企业来说，如何高效实现数字化？

## 一、数字化的核心要素

数字化转型不仅仅是技术升级，更是业务模式和思维方式的变革。

## 二、四步走战略

1. 建立在线品牌（域名 + 官网）
2. 搭建云端基础设施
3. 数字化业务流程
4. 数据分析驱动决策

## 三、成本控制策略

选择一站式服务商可以大幅降低采购和运维成本。91.cn 提供域名、建站、云主机、企业邮箱一体化服务。

## 四、成功案例启示

众多中小企业通过 91.cn 的服务实现了从零到一的数字化跨越。

## 结语

数字化转型不必一步到位，选择对的合作伙伴，从小处着手，逐步推进。`,
  },
  {
    slug: 'seo-optimization-tips',
    title: '网站 SEO 优化实战技巧：提升搜索排名的高效策略',
    category: 'website-building',
    date: '2026-05-10',
    summary: '想让您的网站在搜索引擎中获得更好的排名？本文分享经过验证的 SEO 优化策略，从关键词到外链，助您提升流量。',
    content: `SEO 优化是网站获取免费流量的最重要手段。以下是经过实战验证的 SEO 优化策略：

## 一、技术 SEO 基础

确保网站加载速度快、移动端友好、结构化数据完善。

## 二、内容优化策略

创造高质量、原创的优质内容。合理布局关键词，优化标题和描述。

## 三、用户体验优化

优化页面布局和导航结构，降低跳出率，提升用户停留时间。

## 四、外链建设

通过内容营销、行业合作等方式获取高质量外链。

## 结语

91.cn 网站建设服务内置 SEO 优化工具，帮助您的网站从上线第一天就具备优秀的搜索引擎表现。`,
  },
];

export const faqData = [
  {
    question: '91.cn 域名注册需要多长时间生效？',
    answer: '大多数域名注册后即时生效，部分特殊后缀可能需要 24-48 小时。完成注册后，您可以在账户控制面板中实时查看域名状态，并及时配置 DNS 解析。',
  },
  {
    question: '网站建设完成后可以进行二次修改吗？',
    answer: '当然可以。91.cn 网站建设平台支持随时在线编辑修改，您可以自由调整页面布局、更换模板、更新内容，所有修改实时生效，无需重新部署。',
  },
  {
    question: '云主机支持按需升级配置吗？',
    answer: '支持。91.cn 云主机采用弹性计算架构，您可以根据业务需求随时升级 CPU、内存、带宽和存储空间，升级过程不影响业务正常运行，配置调整即时生效。',
  },
  {
    question: '企业邮箱支持多少个账号？是否支持自定义域名？',
    answer: '91.cn 企业邮箱支持根据企业规模灵活配置账号数量，从 5 个到无限账号均可。所有账号均使用您的企业自定义域名，如 name@yourcompany.com，完美展示品牌形象。',
  },
  {
    question: '如果遇到技术问题，如何获取支持？',
    answer: '我们提供 7×24 小时多渠道技术支持，您可以通过在线客服、电话热线、工单系统或邮件获取专业的技术帮助。紧急问题 15 分钟内响应。',
  },
  {
    question: '91.cn 的服务器部署在哪里？访问速度快吗？',
    answer: '我们的服务器部署在国内顶级数据中心，采用 BGP 多线接入，覆盖电信、联通、移动等主流运营商。同时配备 CDN 加速节点，确保全国乃至全球用户都能获得流畅的访问体验。',
  },
];

export const cases = [
  {
    name: '星辰科技有限公司',
    industry: '科技 / IT',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20star%20logo%20design%20on%20clean%20white%20background%2C%20geometric%20simple%20shape%2C%20corporate%20identity%2C%20professional%20brand%20mark&width=200&height=200&seq=case-logo-1&orientation=squarish',
    result: '建站后月访问量提升 320%，线上获客成本降低 60%',
  },
  {
    name: '绿源环保集团',
    industry: '环保 / 能源',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20leaf%20and%20water%20drop%20logo%20design%20on%20clean%20white%20background%2C%20geometric%20simple%20shape%2C%20corporate%20identity%2C%20professional%20brand%20mark&width=200&height=200&seq=case-logo-2&orientation=squarish',
    result: '数字化转型周期缩短 70%，IT 运维成本降低 45%',
  },
  {
    name: '瀚海国际贸易',
    industry: '贸易 / 跨境电商',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20wave%20and%20globe%20logo%20design%20on%20clean%20white%20background%2C%20geometric%20simple%20shape%2C%20corporate%20identity%2C%20professional%20brand%20mark&width=200&height=200&seq=case-logo-3&orientation=squarish',
    result: '企业邮箱开通后客户信任度提升 85%，邮件回复率提高 40%',
  },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多重安全防护体系，数据加密传输，DDoS 防护，保障您的业务安全稳定运行。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '高效快捷',
    description: '智能自动化部署，域名即时注册，网站分钟级上线，让您的业务快速启动。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业服务',
    description: '7×24 小时专业技术支持团队，一对一顾问式服务，解决您的所有技术难题。',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '高性价比',
    description: '灵活的定价方案，按需付费模式，让中小企业以最低成本享受企业级服务。',
  },
];

export const stats = [
  { value: '10万+', label: '服务企业' },
  { value: '500+', label: '域名后缀' },
  { value: '99.9%', label: '服务可用性' },
  { value: '7×24', label: '技术支持' },
];

export const brandInfo = {
  name: '91.cn',
  fullName: '91.cn 一站式互联网服务平台',
  founded: '2010',
  description: '91.cn 是国内领先的一站式互联网服务平台，自 2010 年成立以来，始终致力于为中小企业和创业者提供域名注册、网站建设、云主机、企业邮箱等全方位的互联网基础服务。我们以"让每个企业都能轻松拥抱互联网"为使命，已累计服务超过 10 万家企业客户。',
  mission: '让每个企业都能轻松拥抱互联网',
  vision: '成为最受信赖的企业数字化服务伙伴',
  values: ['客户至上', '技术创新', '诚信可靠', '合作共赢'],
  milestones: [
    { year: '2010', event: '91.cn 平台正式上线，推出域名注册服务' },
    { year: '2013', event: '推出网站建设服务，客户突破 1 万家' },
    { year: '2015', event: '云主机产品线上线，建成自有数据中心' },
    { year: '2018', event: '推出企业邮箱服务，完成四大产品矩阵布局' },
    { year: '2021', event: '服务客户突破 10 万家，品牌全面升级' },
    { year: '2026', event: '持续创新，推出 AI 智能建站和云计算新方案' },
  ],
  contact: {
    address: '北京市海淀区中关村科技园区',
    phone: '400-810-9191',
    email: 'service@91.cn',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};